webpackJsonp([109],{

/***/ 2383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Start_vue__ = __webpack_require__(3234);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_debabb96_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__ = __webpack_require__(3666);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3664)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Start_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_debabb96_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/video-launcher/Start.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-debabb96", Component.options)
  } else {
    hotAPI.reload("data-v-debabb96", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Start',
  components: {
    BModal: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_32" /* BModal */],
    BButton: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["d" /* BButton */]
  },
  data: function data() {
    return {
      modalShow: true,
      smallToken: null
    };
  },
  created: function created() {
    this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow');
  },

  methods: {
    goToSession: function goToSession() {
      window.location = '/' + this.$i18n.locale + '/' + this.smallToken;
      /* this.$router.push({ name: 'Video', path: this.$i18n.locale + '/' + this.smallToken, params: { token: this.smallToken } }) */
    }
  }
});

/***/ }),

/***/ 3664:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3665);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("93c43bb4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-debabb96\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Start.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-debabb96\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Start.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3665:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\nh1,\nh2 {\n  font-weight: normal;\n}\nul {\n  list-style-type: none;\n  padding: 0;\n}\nli {\n  display: inline-block;\n  margin: 0 10px;\n}\na {\n  color: #35495e;\n}\n#token-input {\n  margin: 0 auto;\n  width: 221px;\n}\n", ""]);

// exports


/***/ }),

/***/ 3666:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "modalPopover",
            centered: "",
            "cancel-disabled": "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": "",
            "hide-header-close": "",
            "hide-footer": "",
            title: _vm.$t("videoSession")
          },
          model: {
            value: _vm.modalShow,
            callback: function($$v) {
              _vm.modalShow = $$v
            },
            expression: "modalShow"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "mx-auto",
              staticStyle: { width: "96px", margin: "20px 0 40px 0" }
            },
            [
              _c("img", {
                attrs: {
                  width: "96px",
                  height: "96px",
                  src: "/static-appopensalud/img/icons/video-icon.svg"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("p", { staticStyle: { "text-align": "center" } }, [
            _vm._v(_vm._s(_vm.$t("needValidToken")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col text-center pt-1" },
            [
              _c("b-input", {
                attrs: {
                  id: "token-input",
                  placeholder: _vm.$t("introduce-token")
                },
                model: {
                  value: _vm.smallToken,
                  callback: function($$v) {
                    _vm.smallToken = $$v
                  },
                  expression: "smallToken"
                }
              }),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { variant: "primary", "align-h": "center" },
                  on: { click: _vm.goToSession }
                },
                [_vm._v(_vm._s(_vm.$t("go-to-session")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-debabb96", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/109.a3b66d4e86cfe5f923c0.js